export default __webpack_public_path__ + "static/media/movies.d066a4cb.jpeg";